import React, { useState, useEffect, useMemo } from 'react';
import {
  Bubble,
  Button,
  Layout,
  Segment,
  SelectMultiple,
  Table,
  notification,
} from 'tea-component';
import CardSlot from '@/pages/intelligence/components/CardSlot';
import {
  fetchFollowingGroups,
  relateGamesAndGroups,
} from '@/pages/intelligence/services/following';
import { getFollowing, setFollowing } from '@/pages/intelligence/services/topcharts';
import { useSelector, useIntl, getLocale } from 'umi';
import '@/pages/intelligence/assets/scss/Following/manage.scss';
import SvgIcon from '@/pages/home/components/SvgIcon';
const { Body, Content } = Layout;
const { expandable, selectable, sortable, pageable } = Table.addons;

const SelectGroup = (props: any) => {
  const {
    cvm,
    groupList,
    groupName,
    setLoading,
    page = 'following',
    mainSegment,
    gameIds,
    handleChangeSeg,
    btnName = '',
    disabledAll = false,
    setCheckList,
    setCheckTrueGameIds,
    isSubOptions = false,
    DEFAULT_GROUPNAME,
    MYFAVOURITE = 'My favourite',
  } = props;

  const { formatMessage } = useIntl(); // 中英切换方法
  const locale = getLocale();
  const { userInfo } = useSelector((state: any) => {
    const { userInfo } = state.home;
    return { userInfo };
  });
  const userId = userInfo?.userid ?? '';

  const speStr = useMemo(() => {
    return groupName?.replace(/\s*/g, '');
  }, [groupName]);

  const selectedGroupsList = useMemo(() => {
    const arrTemp = [];
    for (const n in groupList) {
      const gameList = groupList[n].game_list || [];
      if (gameList.findIndex((item: any) => item.app_id == cvm.app_id) > -1) {
        arrTemp.push(groupList[n].entity_name || '');
      }
    }
    return arrTemp;
  }, [groupList]);

  const [visualValue, setVisualValue] = useState<any>(false);

  // 已选择分组列表数据
  const [selectedGroup, setSelectedGroup] = useState<string[]>(selectedGroupsList);

  const handleChange = (values: any) => {
    setSelectedGroup(values);
  };

  const isAddTo = useMemo(() => {
    return groupName === 'All Games';
  }, [groupName]);

  const addIsDisabled = useMemo(() => {
    // console.log('groupListgroupList', groupList);
    // console.log('disabledAlldisabledAll', disabledAll);
    return disabledAll;
  }, [groupList, disabledAll, gameIds]);

  const options = useMemo(() => {
    return (
      groupList?.map((item: any) => {
        return {
          value: item.entity_name,
          text: item?.entity_name == 'My favourite' ? MYFAVOURITE : item?.entity_name,
        };
      }) || []
    );
  }, [groupList, locale]);

  const handleSubmitFollow = () => {
    const params = {
      entity_type: mainSegment,
      move_type: isAddTo ? 'moveadd' : 'moveto',
      from_entity_names: isAddTo ? '' : groupName, // 如果为moveadd的话，则可以为空
      to_entity_names: selectedGroup,
      game_id: isSubOptions ? [cvm.app_id] : gameIds,
    };
    return relateGamesAndGroups(params);
  };

  const handleSubmitGameDetail = () => {
    const params = {
      user_id: userId,
      game_company_id: gameIds?.[0] || '',
      entity_type: mainSegment,
      is_collection: true,
      group_name: selectedGroup,
    };
    return setFollowing(params);
  };

  const handleFeedback = (isSuccess: boolean) => {
    const notificationConfigMap: any = {
      gameDetail: {
        successMsg: (
          <>
            <span>
              {`${formatMessage({ id: 'dbi_followed_successfully' })} `}
              <a
                href="javascript: void(0)"
                style={{ margin: '0 26px 0 8px', color: '#0076FF' }}
                onClick={() => {
                  setVisualValue(true);
                }}
              >
                {formatMessage({ id: 'dbi_manage' })}
              </a>
            </span>
          </>
        ),
        failedMsg: formatMessage({ id: 'dbi_followed_failed_again' }),
      },
      following: {
        // successMsg: formatMessage({ id: 'dbi_operation_successfully_tips' }),
        successMsg: formatMessage({ id: 'dbi_common_operation_succeed_tips' }),
        failedMsg: formatMessage({ id: 'dbi_added_failed_again' }),
      },
    };
    const notificationConfig = notificationConfigMap[page] || notificationConfigMap.gameDetail;
    if (isSuccess) {
      notification.success({
        unique: true,
        description: notificationConfig.successMsg,
      });
    } else {
      notification.error({
        unique: true,
        description: notificationConfig.failedMsg,
      });
    }
  };

  const handleSubmit = async () => {
    let isSuccess = false;
    setLoading && setLoading(true);

    if (isSubOptions) {
      setCheckList && setCheckList(cvm.app_id + speStr);
      setCheckTrueGameIds && setCheckTrueGameIds(cvm.app_id);
    }

    try {
      if (page == 'following') {
        await handleSubmitFollow();
      } else if (page == 'gameDetail') {
        await handleSubmitGameDetail();
      }
      isSuccess = true;
      handleChangeSeg && handleChangeSeg();
      // initGroups();
    } catch (exception) {
      console.warn(exception);
      isSuccess = false;
    } finally {
      setLoading && setLoading(false);
      handleFeedback(isSuccess);
      setVisualValue(false);
    }
  };

  return (
    <Bubble
      dark
      // content={
      //   addIsDisabled ? 'No grouping. Please create a new group' : ''
      // }
    >
      <SelectMultiple
        className="table-btn-flex-select"
        listWidth={242}
        staging={false}
        // open={visualValue}
        listHeight={348}
        disabled={addIsDisabled}
        options={options}
        // onOpen={() => setVisualValue(true)}
        onChange={handleChange}
        value={selectedGroup}
        boxClassName="table-btn-flex-box"
        button={
          <Bubble dark content={addIsDisabled ? formatMessage({ id: 'dbi_disable' }) : null}>
            <Button type="link" disabled={addIsDisabled} className="select-btn">
              {btnName !== '' ? (
                btnName
              ) : (
                <>
                  {isAddTo
                    ? formatMessage({ id: 'dbi_add_to' })
                    : formatMessage({ id: 'dbi_move_to' })}
                  <SvgIcon type="arrow-down" className="select-btn-icon" />
                </>
              )}
            </Button>
          </Bubble>
        }
        footer={
          <div className="table-footer">
            <Button type="primary" onClick={handleSubmit}>
              {formatMessage({ id: 'dbi_confirm' })}
            </Button>
            <Button
              type="weak"
              onClick={() => {
                // setVisualValue(false);
                const evn = document.createEvent('MouseEvents');
                evn.initEvent('mousedown', true, true);
                document.body.dispatchEvent(evn);
              }}
            >
              {formatMessage({ id: 'dbi_cancel' })}
            </Button>
          </div>
        }
      />
    </Bubble>
  );
};

export default SelectGroup;
